import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BRAND = {
  name: "Bright & Tide Cleaning",
  phone: "437-499-4843",
  phoneHref: "tel:+14374994843",
  email: "gotamenabin274@gmail.com",
  areas: ["Toronto", "Mississauga", "Etobicoke", "Scarborough", "North York", "Vaughan", "Markham"],
  hours: [
    { d: "Monday – Friday", h: "7:00 AM – 8:00 PM" },
    { d: "Saturday", h: "8:00 AM – 6:00 PM" },
    { d: "Sunday", h: "By appointment" },
  ],
};
